export default function RegistrationFormContainer({children, heading='', text='', linkText='', linkHref=''}) {
    return (
        <div className="registration-form__wrapper">
            <div className="registration-form__top">
                <a href="https://www.enterprisingbarnsley.co.uk/">Return to Enterprising Barnsley's Website</a>
            </div>
            <div className="registration-form__middle">
                <div className="registration-form__outer">
                    <img src="/assets/logos/myeb.png" />
                    <h3>{heading}</h3>
                </div>
                {children}
            </div>
            <div className="registration-form__bottom">

                <p>{text} <a href={linkHref}>{linkText}</a></p>
            </div>
        </div>
    )
}
